module.exports = __webpack_public_path__ + "img/block_1.4c9bd95a.webp";